import React from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";

PimStatusBadge.propTypes = {
    status: PropTypes.number.isRequired
};

function PimStatusBadge({status}) {
    if (!status) {
        return null;
    }

    switch (status) {
        case 1:
            return <Badge rounded color={'warning'}>À enrichir</Badge>
        case 2:
            return <Badge rounded>Proposé</Badge>
        case 3:
            return <Badge rounded color={'online'}>Validé</Badge>
    }
}

export default PimStatusBadge;
